import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import './PracticePerfectProgress.css';
import Spinner from '../../Spinner/Spinner';
import loadingIcon from '../../Spinner/loadingIcon.gif';
import { handleException } from '../../../app/util/util';
export default function PPQuizCenterProgress(props) {
    var ppProgrPageInfo = props.ppProgrPageInfo;
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const { isbn } = useParams(); const history = useHistory();
    const [ppQuizCentResults, setPpQuizCentResults] = useState();
    const [isPpQuizCentLoading, setIsPpQuizCentLoading] = useState(true);
    const [ppQuizCentResCurrPage, setPpQuizCentResCurrPage] = useState(1);
    const [ppQuizCentResTotalPages, setPpQuizCentResTotalPages] = useState(0);
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    const fetchQuizCentResults = (resCurrPage) => {
        var reqData = {
            "userVO": {
                "userId": userVO.userId,
                "userRole": userVO.userRole,
                "schoolId": userVO.schoolId,
                "userRoleId": userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": "",
                    "themisProductId": "",
                    "lastReadPageNum": "",
                    "lastReadChapterId": "",
                    "lastReadSectionId": "",
                    "themisSubjectAreaId": "",
                    "lastReadParagraphId": "",
                    "lastViewedOutlineId": "",
                    "lastReadSubSectionId": "",
                    "schoolId": userVO.schoolId,
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "EReader",
                    "pageNavigatingTo": "Bookshelf",
                    "ppSubjectAreaTagId": ppProgrPageInfo.SATagId
                },
                "sessionVO": getSessionVO()
            },
            "ppSubjectAreaTagId": ppProgrPageInfo.SATagId,
            "ppQuizResultVO": { "perPage": 5, "page": resCurrPage },
            "ppProductVO": { "productId": ppProgrPageInfo.ProductID }
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(reqData),
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        };
        fetch(`${localStorage.getItem('ENV')}/managePP/getQuizCenterProgress`, requestOptions)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data.ppQuizResultVOList) {
                        var ppQuizResultList = Array.isArray(data.ppQuizResultVOList) ? data.ppQuizResultVOList : [data.ppQuizResultVOList];
                        ppQuizResultList = ppQuizResultList.map(ppQuizResult => {
                            if (ppQuizResult.ppSubTopicVOList) {
                                ppQuizResult.ppSubTopicVOList = Array.isArray(ppQuizResult.ppSubTopicVOList) ? ppQuizResult.ppSubTopicVOList : [ppQuizResult.ppSubTopicVOList];
                            }
                            return { ...ppQuizResult, quizResult_expand_status: false }
                        });
                        if (resCurrPage > 1) {
                            setPpQuizCentResults([...ppQuizCentResults, ...ppQuizResultList]);
                        } else {
                            setPpQuizCentResults(ppQuizResultList);
                        }
                        setPpQuizCentResTotalPages(Number(data.totalPages));
                    }
                    setIsPpQuizCentLoading(false);
                } else if (data.wkErrorCode) {
                    handleException(data);
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    useEffect(() => {
        fetchQuizCentResults(1);
    }, []);
    function handleQuizCenNavigation() {
        history.push(`/pp-quiz-center/${isbn}`);
    }
    function handleQuizCentQrExpCollpAll(qrExpandSt) {
        const newQrExpandState = ppQuizCentResults.map(ppQuizResult => {
            return { ...ppQuizResult, quizResult_expand_status: qrExpandSt }
        });
        setPpQuizCentResults(newQrExpandState);
    }
    function handleQuizCentQrExpCollp(qrExpandIndex, qrExpandSt) {
        const newQrExpandState = ppQuizCentResults.map((ppQuizResult, index) => {
            if (index === qrExpandIndex) {
                return { ...ppQuizResult, quizResult_expand_status: qrExpandSt }
            }
            return ppQuizResult;
        });
        setPpQuizCentResults(newQrExpandState);
    }
    function dateTimeModification(beforeFormatDT) {
        var afterFDTZone = moment.tz.guess(),
            afterFDT = moment.utc(beforeFormatDT).clone().tz(afterFDTZone),
            afterFormatDT = moment(afterFDT).format('MMMM DD, YYYY hh:mm A');
        return afterFormatDT;
    }
    function handleReviewQuizResult(quizInstanceId) {
        history.push(`/pp-quiz/results/${isbn}/${ppProgrPageInfo.ProductID}/${ppProgrPageInfo.SATagId}/${quizInstanceId}`);
    }
    function handleQuizCentQrViewMoreBtn() {
        setPpQuizCentResCurrPage(ppQuizCentResCurrPage + 1);
        setIsPpQuizCentLoading(true);
        fetchQuizCentResults(ppQuizCentResCurrPage + 1);
    }
    return (
        <>
            <Spinner
                loading={isPpQuizCentLoading}
                imageSrc={loadingIcon}
                imageStyle={{ marginTop: "20%", width: "50px" }}
                overlayBackground="rgba(0,0,0,0)"
            />
            {
                isPpQuizCentLoading === false &&
                <>
                    {
                        ppQuizCentResTotalPages === 0 ?
                            <div className='mt-3 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding'>
                                <p className='ppNoQuizCentProgTitle'>
                                    You haven't built any quizzes. Visit the <a onClick={() => handleQuizCenNavigation()} className='ppQuizCentLink'>Quiz Center</a> to get started.
                                </p>
                            </div> :
                            <>
                                <div className='mt-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding'>
                                    <div style={{ display: "flex" }}>
                                        <div className='col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 no-padding'>
                                            <p className='ppQuizCentProgTitle'>
                                                Your progress on all quizzes built in the Quiz Center
                                            </p>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right no-padding">
                                            <a onClick={() => handleQuizCentQrExpCollpAll(true)}>
                                                <span className="ppQuizCentPreviewExpCollpAll">Expand All</span>
                                            </a>
                                            <span> | </span>
                                            <a onClick={() => handleQuizCentQrExpCollpAll(false)}>
                                                <span className="ppQuizCentPreviewExpCollpAll">Collapse All</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
                                    {
                                        ppQuizCentResults.map((ppQuizResult, index) => {
                                            return (
                                                <>
                                                    <div className='mb-1' style={{ display: "flex" }}>
                                                        <div className='ppQuizCentQuizNames col-xl-9 col-lg-9 col-md-8 col-sm-8 col-8 no-padding'>
                                                            {
                                                                ((ppQuizResult.quizType).toLowerCase() === 'summative a' || (ppQuizResult.quizType).toLowerCase() === 'comparative1') ?
                                                                    `Comparative Quiz A: Quiz ` :
                                                                    ((ppQuizResult.quizType).toLowerCase() === 'summative b' || (ppQuizResult.quizType).toLowerCase() === 'comparative2') ?
                                                                        `Comparative Quiz B: Quiz ` :
                                                                        ((ppQuizResult.quizType).toLowerCase() === 'comparative3') ?
                                                                            `Comparative Quiz C: Quiz ` :
                                                                            ((ppQuizResult.quizType).toLowerCase() === 'comparative4') ?
                                                                                `Comparative Quiz D: Quiz ` :
                                                                                ((ppQuizResult.quizType).toLowerCase() === 'cumulative' || (ppQuizResult.quizType).toLowerCase() === 'cumulative2') ?
                                                                                    `Comparative Quiz: All Topics: Quiz ` : (ppQuizResult.quizType + ': Quiz ')
                                                            }{ppQuizResult.quizAttempt}
                                                            <div className="mt-2 ppQuizCentQuizTxt">
                                                                <span>{dateTimeModification(ppQuizResult.completedDate)} | </span>
                                                                <span>Total Questions: {ppQuizResult.totalQuestions}</span>
                                                            </div>
                                                        </div>
                                                        <div className="ppQuizCentExpCollBtnStyle col-xl-3 col-lg-3 col-md-4 col-sm-4 col-4 no-padding">
                                                            <button className="ppQuizCentExpCollBtn" onClick={() =>
                                                                handleQuizCentQrExpCollp(index, ppQuizResult.quizResult_expand_status ? false : true)}>
                                                                {ppQuizResult.quizResult_expand_status === true ? 'Collapse' : 'Expand'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="progress ppQuizCentQrProgress mb-1">
                                                        {
                                                            ppQuizResult.score === undefined ?
                                                                <div className="progress-bar ppQuizCentQrProgressBarNo">No Score</div> :
                                                                Number(ppQuizResult.score) > 0 ?
                                                                    <>
                                                                        <div className="progress-bar ppQuizCentQrProgressBar" style={{ width: (Number(ppQuizResult.score) + '%') }}>
                                                                            {Number(ppQuizResult.score) > 16 ? (Number(ppQuizResult.score).toFixed(2) + '%') : null}
                                                                        </div>
                                                                        {Number(ppQuizResult.score) > 16 ? null : <div className="progress-bar ppQuizCentQrProgressBarLess16">{Number(ppQuizResult.score).toFixed(2) + '%'}</div>}
                                                                    </> :
                                                                    <div className="progress-bar ppQuizCentQrProgressBarZero">{ppQuizResult.score + '%'}</div>
                                                        }
                                                    </div>
                                                    <a className='ppQuizCentQrView' onClick={() => handleReviewQuizResult(ppQuizResult.instanceId)}>
                                                        Review Results
                                                    </a>
                                                    {
                                                        ppQuizResult.quizResult_expand_status === true ?
                                                            ppQuizResult.ppSubTopicVOList && ppQuizResult.ppSubTopicVOList.map(ppQrSubTopic => {
                                                                return (
                                                                    <>
                                                                        <div style={{ marginLeft: '6%' }}>
                                                                            <div className='mt-1 mb-2' style={{ display: "flex" }}>
                                                                                <div className='ppQuizCentQrSubTopicNames col-xl-9 col-lg-9 col-md-8 col-sm-8 col-8 no-padding'>
                                                                                    {ppQrSubTopic.customerFacingSubTopicName}
                                                                                </div>
                                                                                <div className="ppQuizCentQrSubTopicQuesTxt col-xl-3 col-lg-3 col-md-4 col-sm-4 col-4 no-padding">
                                                                                    {((Number(ppQrSubTopic.totalQuestions) > 1 ? `Questions: ` : `Question: `) + ppQrSubTopic.totalQuestions)}
                                                                                </div>
                                                                            </div>
                                                                            <div className="progress ppQuizCentQrSubTopicProgress mt-1 mb-3">
                                                                                {
                                                                                    ppQrSubTopic.score === undefined ?
                                                                                        <div className="progress-bar ppQuizCentQrSubTopicProgressBarNo">No Score</div> :
                                                                                        Number(ppQrSubTopic.score) > 0 ?
                                                                                            <>
                                                                                                <div className="progress-bar ppQuizCentQrSubTopicProgressBar" style={{ width: (Number(ppQrSubTopic.score) + '%') }}>
                                                                                                    {Number(ppQrSubTopic.score) > 16 ? (Number(ppQrSubTopic.score).toFixed(2) + '%') : null}
                                                                                                </div>
                                                                                                {Number(ppQrSubTopic.score) > 16 ? null : <div className="progress-bar ppQuizCentQrSubTopicProgressBarLess16">{Number(ppQrSubTopic.score).toFixed(2) + '%'}</div>}
                                                                                            </> :
                                                                                            <div className="progress-bar ppQuizCentQrSubTopicProgressBarZero">{ppQrSubTopic.score + '%'}</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                            : null
                                                    }
                                                    <hr className='w-100'></hr>
                                                </>
                                            )
                                        })
                                    }
                                    {
                                        (ppQuizCentResTotalPages > 1 && (ppQuizCentResCurrPage < ppQuizCentResTotalPages)) ?
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center no-padding">
                                                <button onClick={() => handleQuizCentQrViewMoreBtn()} className='ppQuizCentQrViewMoreBtn'>VIEW MORE</button>
                                            </div> : null
                                    }
                                </div>
                            </>
                    }
                </>
            }
        </>
    )
}